import { REDIRECT_URL, TAX1099_REDIRECT_URL } from '../../constants/global.constants';

const RedirectToApp = () => {
    const email = localStorage.getItem('userEmail') || '';

    const redirectToApp = () => {

        if (typeof window !== 'undefined') {
            let targetUrl = '';
            if (clientType === "salesbot2290ai") {
            targetUrl = `${REDIRECT_URL}/login?email=${encodeURIComponent(email)}`;
            }
            else{
            targetUrl = `${TAX1099_REDIRECT_URL}`;
            }
            
            try {
                if (window.top) {
                    window.top.location.href = targetUrl;
                } else {
                    window.open(targetUrl, '_blank');
                }
            } catch (err) {
                window.open(targetUrl, '_blank');
            }
        }

    };

    const clientType = process.env.REACT_APP_CLIENT

    return (
        <div>
            <h2 className='font-bold'>Welcome back!</h2>
            <h3>
                Great to see you again. Ready to pick up right where you left off? Just log in and continue your filing journey—smooth and simple.
            </h3>
            <button
                onClick={redirectToApp}
                className={ 
                    clientType === "salesbot2290ai" ?
                    'bg-primary px-8 py-2 rounded-md text-white mt-2'
                :
                    'bg-[#114175] px-8 py-2 rounded-md text-white mt-2'
            }
            >
                Go to App
            </button>
        </div>
    );
};

export { RedirectToApp };
